import { useSubscription } from "../context";
import { isStorageFull, isLicensesExhausted } from "../utils";
import { ReadOnlyWrapper } from "./ReadOnlyWrapper";

type FeatureKey =
  | "storage:available"
  | "licenses:available"
  | "subscription:active"
  | "write:allowed";

type Props = {
  has: FeatureKey;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

export const FEATURE = ({ has, fallback = null, children }: Props) => {
  const { role, subscription, isReadOnly } = useSubscription();

  if (has === "write:allowed") {
    if (isReadOnly) {
      return fallback != null ? <>{fallback}</> : <ReadOnlyWrapper>{children}</ReadOnlyWrapper>;
    }
    return <>{children}</>;
  }

  const allowed = (() => {
    switch (has) {
      case "storage:available":
        return !isStorageFull(
          subscription.storage_used,
          subscription.storage_total,
        );
      case "licenses:available":
        return role === "admin"
          ? !isLicensesExhausted(
              subscription.licenses_consumed,
              subscription.licenses_total,
            )
          : subscription.has_license;
      case "subscription:active":
        return subscription.status === "active";
      default:
        return true;
    }
  })();

  return allowed ? <>{children}</> : <>{fallback}</>;
};
